import { render } from "./TaskTeaser.vue?vue&type=template&id=659f28f8&scoped=true"
import script from "./TaskTeaser.vue?vue&type=script&lang=js"
export * from "./TaskTeaser.vue?vue&type=script&lang=js"

import "./TaskTeaser.vue?vue&type=style&index=0&id=659f28f8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659f28f8"]])

export default __exports__